<div class="flex-1 d-flex fd-col ai-stretch">

  <div class="flex-1 d-flex" [ngClass]="isVertical ? 'fd-row jc-between ai-end' : 'fd-col jc-between ai-start'">

    <ng-container *ngFor="let barHeight of barHeights">

      <div [ngStyle]="{
        'height': (isVertical ? barHeight : barWidth),
        'width': (isVertical ? barWidth : barHeight)
      }">

        <ngx-skeleton-loader [theme]="{
          height: '100%',
          width: '100%'
        }"></ngx-skeleton-loader>

      </div>

    </ng-container>

  </div>

</div>
